// extracted by mini-css-extract-plugin
export default {"CommentBox":"IssueCommentEditor-module__CommentBox--JfMp5","EditorMarginContainer":"IssueCommentEditor-module__EditorMarginContainer--qYWwo"};